import TableExport from 'tableexport'

TableExport.prototype.typeConfig.date.assert = function () {
  return false
}
TableExport.prototype.typeConfig.number.assert = function (value) {
  if (value.match(/^\d+\.\d+$/)) {
    return true
  } else if (value && value.startsWith('0') && value.length > 1) {
    return false
  } else if (value.match(/^-?\d+$/)) {
    return true
  }
  return false
}

function createTableFromSheetData({ headers, rows }) {
  const table = document.createElement('table')
  const thead = document.createElement('thead')
  const headerRow = document.createElement('tr')

  for (const header of headers) {
    const th = document.createElement('th')
    th.innerText = header
    headerRow.appendChild(th)
  }
  thead.appendChild(headerRow)
  table.appendChild(thead)

  const tbody = document.createElement('tbody')
  for (const row of rows) {
    const tr = document.createElement('tr')
    for (const col of row) {
      const td = document.createElement('td')
      td.innerText = col == null ? '' : col
      tr.appendChild(td)
    }
    tbody.appendChild(tr)
  }
  table.appendChild(tbody)

  return table
}

export function exportWithTableExport(sheetData, fileName) {
  const table = createTableFromSheetData(sheetData)
  const tempID = 'temp-table-' + new Date().getTime()
  table.id = tempID
  table.style.display = 'none'
  document.body.appendChild(table)

  const exportedTable = TableExport(table, {
    formats: ['xlsx', 'xls'],
    filename: '表單',
  })
  table.remove()

  const xlsxData = exportedTable.getExportData()[tempID].xlsx
  exportedTable.export2file(
    xlsxData.data,
    xlsxData.mimeType,
    fileName,
    xlsxData.fileExtension,
    xlsxData.merges,
    xlsxData.RTL,
    xlsxData.sheetname
  )
}
